import { lazy } from "react";

export const WorkspaceLicensesView = lazy(
  () => import("./WorkspaceLicensesView"),
);
